module.exports = __webpack_public_path__ + "resources/img/teacher-img.f640d723.png";